import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Headphones } from "lucide-react";
import { addNewStyle, API, CRISTP_ID, wait } from "../../../Helper";
import "./sidebarHello.css";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";
import { TbWorld } from "react-icons/tb";
import storage from '../../../Storage';
import axios from "axios";
const REACT_APP_LG_LOGO = process.env.REACT_APP_LG_LOGO
const REACT_APP_SM_LOGO = process.env.REACT_APP_SM_LOGO

const SupportButton = styled.button`
  display: flex;
  align-items: center;
  background-color: #27272a;
  border: none;
  width: 200px;
  border-radius: 20px;
  padding-right: 20px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #2a2a2a;
  }
`;

const IconWrapperSupport = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #57d219;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  margin-right: 12px;
`;
const IconWrapperTelegram = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #24A1DE;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  margin-right: 12px;
`;

const Text = styled.span`
  color: white;
  font-size: 14px;
  font-weight: 500;
  display: ${(props) => (props.isCollapsed ? "none" : "block")};
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 8px;
  margin: 0px 12px;
`;

const Title = styled.div`
  color: #9ca3af;
  font-size: 14px;
  margin-left: 10px;
`;

const Flex = styled.div`
  display: flex;
  justify-content: center;
`;

const LanguageButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #3c4142;
  color: white;
  padding: 10px 12px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: linear-gradient(
      to left,
      rgb(50, 55, 56), rgb(55, 99, 80)
    ); /* Apply hover effect here */
  }
`;

const ButtonText = styled.span`
    font-size: 14px;
    display: ${(props) => (props.isCollapsed ? "none" : "block")};
   
  }
  `;

const StyledChevronRight = styled(ChevronRight)`
  color: #9ca3af;
  display: ${(props) => (props.isCollapsed ? "none" : "block")};
`;

const SidebarContainer = styled.nav`
  color: rgb(69, 183, 12);
  background-color: rgb(41, 45, 46);
  transition: 0.2s linear;
  width: ${(props) => (props.isCollapsed ? "86px" : "242px")};
  height: 100vh;
  padding: ${(props) => (props.isCollapsed ? "12px 0px" : "12px 0px")};
  color: #ffffff;
  position: fixed;
  top: -12px;
  left: 0;
  z-index: 999;
  transition: width 0.3s ease;
  overflow-y: auto;
`;

const SidebarTop = styled.div`
  background-color: rgb(41, 45, 46);
  width: ${(props) => (props.isCollapsed ? "86px" : "242px")};
  padding: ${(props) => (props.isCollapsed ? "20px" : "9px")};
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.1);
  color: #fff;
  display: flex;

  position: fixed;
  top: 0px;
  z-index: 9999;
`;

const CircularBarContainer = styled.button`
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 5px;
  // background-color: rgb(26, 28, 32);
  background-color: #3a4142;
  box-shadow: transparent 0px 2px 4px 0px;
  z-index: 9999;
  position: absolute;
  top: 12px;
  padding: 5px;
  left: 18px;
  transition: right 0.2s linear;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white !important;
  font-size: 20px;
`;

const MenuItemLink = styled(Link)`
  display: flex;
  align-items: center;
  color: ${(props) => (props.color ? "white" : "white")};
  justify-content: center;
  justify-content: ${(props) =>
    props.isCollapsed ? "center" : "left "}!important;
  padding: ${(props) => (props.isCollapsed ? "2px" : "2px 8px")};
  cursor: pointer;
  position: relative;
  margin-top: 8px;
  // border:1px solid green;
  margin: ${(props) => (props.isCollapsed ? "3px" : "5px 7px")};
  border-radius: 5px;
  // background-color:#3c4142;
  background-color: rgb(50, 55, 56) !important;
  width: 93%;
  // border-top-right-radius: 20px;
  // border-bottom-right-radius: 20px;
  text-decoration: none;
  font-weight: ${(props) =>
    props.isVIP || props.isPromotion ? "bold" : "normal"};
  font-style: ${(props) => (props.isVIP ? "italic" : "normal")};

  &:hover {
    background: linear-gradient(
      to left,
      rgb(50, 55, 56), rgb(55, 99, 80)
    ); /* Apply hover effect here */
  }
  ${(props) =>
    !props.isCollapsed &&
    props.active &&
    `
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          color:white;
          // border:1px solid green;
          border-radius:5px;
          // margin:0px 5px;
          background: linear-gradient(to left, rgb(50, 55, 56), rgb(55, 99, 80));
          // background-color: rgba(76,175,80,0.2);
          // border-top-right-radius: 20px;
          // border-bottom-right-radius: 20px;

        }
      `}

  ${(props) =>
    props.isCollapsed &&
    `
        justify-content: center;
        padding: 8px 0;
        color:white;
        
      `}
`;

const IconWrapper = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${(props) => (props.isCollapsed ? "0" : "3px")};
  position: relative;
  z-index: 1;

  ${(props) =>
    props.isCollapsed &&
    props.active &&
    `
        background-color: #2E3238;
        border-radius: 50%;
        width: 50px;
        height: 50px;
      `}
`;

const Icon = styled.img`
  width: 40px;
  height: 40px;
`;

const Label = styled.span`
  font-size: ${(props) => (props.isVIP || props.isPromotion ? "16px" : "14px")};
  font-weight: ${(props) =>
    props.isVIP || props.isPromotion ? "bold" : "normal"};
  font-style: ${(props) =>
    props.isVIP || props.isPromotion ? "italic" : "normal"};
  position: relative;
  z-index: 1;

  color: ${(props) => {
    if (props.isVIP) return "#EB5D0E";
    if (props.isPromotion) return "#5DDB1B";
    return "#808A94";
  }} !important;
  display: ${(props) => (props.isCollapsed ? "none" : "inline")};
`;

const Divider = styled.div`
  height: 1px;
  background-color: #353535;
  margin: 8px ${(props) => (props.isCollapsed ? "4px" : "16px")};
`;

const SwitcherContainer = styled.div`
  display: flex;

  // border-radius: 9999px;
  text-align: end;
  // padding: 4px;
`;

const Tab = styled.div`
  width: 100%;

  // padding: 8px 28px;
  // border-radius: 9999px;
  // font-size: 14px;
  // font-weight: 500;
  // transition: background-color 0.3s, color 0.3s;
`;

const DropdownMenu = styled.div`
  align-items: center;
  color: white;
  padding: 2px 8px;
  cursor: pointer;
  position: relative;
  // margin-top: 8px;
  margin: 5px 7px;
  border-radius: 5px;
  // background-color: #3c4142;
  width: 93%;

  // border:1px solid brown;
  text-decoration: none;
  font-weight: normal;
  font-style: normal;
  text-align: center;
  justify-content: center;
  padding: 2px 0px;
  display: ${(props) => (props.isOpen ? "block" : "none")};
  // background-color: #3a4142;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  margin-top: -7px;
  // margin-left: 10px;
  // margin-right: 10px
  font-weight: ${(props) =>
    props.isVIP || props.isPromotion ? "bold" : "normal"};
  font-style: ${(props) => (props.isVIP ? "italic" : "normal")};
`;

const DropdownItem = styled(Link)`
  display: block;
  color: white;
  padding: 15px 12px;
  textalign: center;
  text-decoration: none;
  border-radius: 5px;
  background-color: #3c4142;
  margin-top: 10px;

  &:hover {
    background: linear-gradient(to left, rgb(50, 55, 56), rgb(55, 99, 80));
  }
`;

const SidebarHello = ({ isCollapsed, setIsCollapsed }) => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("Casino");
  const tabs = ["Casino", "Sports"];
  const [lotteryDropdownOpen, setLotteryDropdownOpen] = useState(false); // State to control dropdown

  const [settings, setSettings] = useState()

  const [loaded, setLoaded] = useState(false);

 


   const icons = {
  telegram: "/assets/images/telegram.webp",
  whatsapp: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/2044px-WhatsApp.svg.png",
  email: "/assets/images/email.webp",
  facebook: "/assets/images/facebook.webp",
  instagram: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/2048px-Instagram_icon.png",
  youtube: "/assets/images/youtube.webp",
  viber: "/assets/images/viber.webp",
};

  
const fetchSettings = async () => {
   try {
        const response = await axios.get(`${API}/admin/websiteconfig`);
        const data = response.data;

        console.log(data.data.contactChannels.social);
        if (data?.data?.contactChannels?.social) {
          setSettings(data?.data?.contactChannels?.social);
        }
        // if (data?.data?.contactChannels?.support) {
        //   setSupportSettings(data?.data?.contactChannels?.support);
        // }
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
};

function telegramLink() {
  const telegram = settings?.social?.find(
    (item) => item.platform === "telegram" && item.is_active
  );
  
  if (telegram?.value) {
    // Remove accidental spaces in the URL
    const cleanUrl = telegram.value.replace(/\s+/g, "");
    window.location.href = cleanUrl;
  } else {
    console.warn("No active Telegram link found");
  }
}


  useEffect(() => {

    fetchSettings();

    const toggleValue = localStorage.getItem("isCollapsed");
    if (toggleValue !== null) {
      setIsCollapsed(toggleValue === "true");
    }


  }, []);

  const toggleSidebar = () => {
    const newIsCollapsed = !isCollapsed;
    setIsCollapsed(newIsCollapsed);
    localStorage.setItem("isCollapsed", newIsCollapsed.toString());
  };



  const menuItems = [
    {
      name: "Home ",
      icon: REACT_APP_SM_LOGO,
      path: "/",
    },
     {
      name: "Sports",
      icon: "/assets/bcimages/Casino/slot.svg",
      path: "/casino/sports"
      },
    {
      name: "Casino",
      icon: "/assets/bcimages/sidebar/svgexport-1.svg",
      path: "/casino",
      hasSubMenu: true,
        subMenu: [
          { name: 'Originals', icon: '/assets/bcimages/sidebar/bc-original.svg', path: '/casino/originals' },
          { name: 'Hot Games', icon: '/assets/bcimages/sidebar/icon/hot-games.svg', path: '/casino/hot-games' },
          { name: 'Slots', icon: '/assets/bcimages/sidebar/icon/slot.svg', path: '/casino/slots' },
          { name: 'Live Casino', icon: '/assets/bcimages/sidebar/icon/live-casino.svg', path: '/casino/live-casino' },
          // { name: 'Game Show', icon: '/assets/bcimages/sidebar/icon/gameShow.svg', path: '/casino/game-show' },
          // { name: 'Table Games', icon: '/assets/bcimages/sidebar/icon/table-games.svg', path: '/casino/table' },
          { name: 'Provider', icon: '/assets/bcimages/sidebar/icon/providers.svg', path: '/casino/providers' },
     
        ]
      },
   
     
    {
      name: "Promotions",
      icon: "/assets/bcimages/sidebar/promotion.svg",
      color: "rgb(93, 219, 28)",
      path: "/promotions",
    },
    { divider: true },
    // { name: 'Most Populars', icon: 'https://static.nanogames.io/assets/myfavorite.466f0741.png', path: '/populars' },
    {
      name: "Rakeback",
      icon: "/assets/bcimages/sidebar/Lottery.svg",
      path: "/rakeback",
    },
    {
      name: "Affiliate",
      icon: "/assets/bcimages/sidebar/affiliate.svg",
      path: "/affiliate",
    },
    {
      name: "VIP Club",
      icon: "/assets/bcimages/sidebar/vip.svg",
      color: "rgb(235, 93, 15)",
      path: "/vip-club",
    },
    {
      name: "Bonus",
      icon: "/assets/bcimages/sidebar/bonus.svg",
      color: "rgb(235, 93, 15)",
      path: storage.getKey('logged') ? "/bonus" : "/bonusSignup",
    },

    {
      name: "Provably Fair",
      icon: "/assets/bcimages/sidebar/probablyfair.svg",
      color: "rgb(235, 93, 15)",
      path: "/provably-fair",
    },

    { divider: true },
    {
      name: "About Us",
      icon: "https://static.nanogames.io/assets/myfavorite.466f0741.png",
      color: "rgb(93, 219, 28)",
      path: "/about-us",
    },
    {
      name: "FAQ",
      icon: "https://static.nanogames.io/assets/livecasino.80cdfcc2.png",
      color: "rgb(93, 219, 28)",
      path: "/faq",
    },
  ];


  

  return (
    <SidebarContainer isCollapsed={isCollapsed}>
      <SidebarTop>
        <CircularBarContainer onClick={toggleSidebar}>
          <img
            src="/assets/bcimages/sidebar/bcmenu.svg"
            width={24}
            height={24}
          />
        </CircularBarContainer>

        <SwitcherContainer style={{ margin: "4px" }}>
          <div className="bc-logo">
            <img
              src={REACT_APP_LG_LOGO}
              className="bc-logo"
              style={{ width: "70%" }}
            />
          </div>
        </SwitcherContainer>
      </SidebarTop>

      <div style={{ marginTop: "70px" }}>
        {menuItems.map((item, index) =>
          item.divider ? (
            <></>
          ) : 
          item.hasSubMenu ? (
            <div key={`divider-${item.name}-${index}`}>
              <MenuItemLink
                to={item.path}
                active={
                  location.pathname === item.path ||
                  item.subMenu.some(
                    (subItem) => location.pathname === subItem.path
                  )
                } // Check if the current path matches the parent or any submenu path
                color={item.color}
                isCollapsed={isCollapsed}
                style={{ padding: "0px 13px" }}
                onClick={() => setLotteryDropdownOpen(!lotteryDropdownOpen)} // Toggle dropdown on click
              >
                <IconWrapper
                  active={
                    location.pathname === item.path ||
                    item.subMenu.some(
                      (subItem) => location.pathname === subItem.path
                    )
                  }
                  isCollapsed={isCollapsed}
                >
                  <Icon
                    src={item.icon}
                    alt={item.name}
                    style={{ width: "25px", height: "25px" }}
                  />
                </IconWrapper>

                <Label
                  active={
                    location.pathname === item.path ||
                    item.subMenu.some(
                      (subItem) => location.pathname === subItem.path
                    )
                  }
                  isCollapsed={isCollapsed}
                  style={{ width: "100%", justifyItems: "end" }}
                >
                  <span
                    className="game-fonts"
                    style={{
                      color: "white",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    {item.name}
                  </span>
                  {/* Arrow icon */}
                  <span
                    style={{
                      padding: "4px",
                      backgroundColor: "#464f50",
                      borderRadius: "3px",
                      marginLeft: "50%",
                      fontWeight: "bolder",
                    }}
                  >
                    <IoIosArrowDown
                      isOpen={lotteryDropdownOpen} // Pass the state for rotation
                      style={{
                        color: "white",
                        fontSize: "18px",
                        fontWeight: "bolder",
                        transition: "transform 0.3s ease", // Smooth transition
                        transform: lotteryDropdownOpen
                          ? "rotate(180deg)"
                          : "rotate(0deg)", // Rotate when open
                      }}
                    />
                  </span>
                </Label>
              </MenuItemLink>

              {/* Dropdown menu for the Lottery section */}
              <DropdownMenu isOpen={lotteryDropdownOpen}>
                {item.subMenu.map((subItem, subIndex) => (
                  <MenuItemLink
                    key={`sub-item-${subIndex}`}
                    to={subItem.path}
                    active={location.pathname === subItem.path} // Apply active state
                    style={{
                      padding: "4px 6.5px",
                      margin: "5px 0px",
                      width: "100%",
                      //  border:"1px solid pink",
                      backgroundColor:
                        location.pathname === subItem.path
                          ? "#333"
                          : "transparent",
                    }}
                  >
                    <IconWrapper>
                      <Icon
                        src={subItem.icon}
                        alt={subItem.name}
                        style={{ width: "25px", height: "25px" }}
                      />
                    </IconWrapper>
                    <Label
                      active={location.pathname === subItem.path}
                      isCollapsed={isCollapsed}
                    >
                      <span
                        className="game-fonts"
                        style={{
                          color: "white",
                          fontSize: "13px",
                          fontWeight: "bold",
                        }}
                      >
                        {subItem.name}
                      </span>
                    </Label>
                  </MenuItemLink>
                ))}
              </DropdownMenu>
            </div>
          ) : (
            <MenuItemLink
              key={item.name}
              to={item.path}
              active={location.pathname === item.path}
              color={item.color}
              isCollapsed={isCollapsed}
              style={{
                backgroundColor:
                  location.pathname === item.path ? "#333" : "transparent",
              }}
            >
              <IconWrapper
                active={location.pathname === item.path}
                isCollapsed={isCollapsed}
              >
                <Icon
                  src={item.icon}
                  alt={item.name}
                  style={{ width: "25px", height: "25px" }}
                />
              </IconWrapper>
              <Label
                active={location.pathname === item.path}
                isCollapsed={isCollapsed}
              >
                <span
                  className="game-fonts"
                  style={{
                    color: "white",
                    fontSize: "13px",
                    fontWeight: "bold",
                  }}
                >
                  {item.name}
                </span>
              </Label>
            </MenuItemLink>
          )
        )}

        <Divider />

        <Flex style={{ marginTop: "15px", marginBottom: "15px" }}>
          <Container>
            {/* <Title>Language Options</Title> */}
            <LanguageButton>
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  textAlign: "center",
                  alignItems: "center",
                }}
              >
                <TbWorld size={25} />

                <ButtonText
                  isCollapsed={isCollapsed}
                  className="game-fonts"
                  style={{ fontWeight: "bold" }}
                >
                  English
                </ButtonText>
              </div>

              <StyledChevronRight isCollapsed={isCollapsed} size={24} />
            </LanguageButton>
          </Container>
        </Flex>

        <Divider />


        {settings && settings.length>0 && settings
          .filter((s) => s.is_active) // only active platforms
          .map((s, index) => (
            <Flex key={index}
              style={{ marginTop: "20px", marginBottom: "20px" }}>
              <SupportButton onClick={() => window.open(s.value, "_blank")}>
                <IconWrapperTelegram>
                  <img style={{ width: "30px" }} src={icons[s.platform]} />
                </IconWrapperTelegram>
                <Text isCollapsedMobile={isCollapsed}>
                  {s.platform.charAt(0).toUpperCase() + s.platform.slice(1)}
                </Text>
              </SupportButton>
            </Flex>
          ))}

        {/* <Flex
          
          style={{ marginTop: "20px", marginBottom: "20px" }}
        >
          <SupportButton onClick={telegramLink}>
            <IconWrapperTelegram>
              <img style={{width: "30px"}} src="/assets/images/telegram.webp"/>
            </IconWrapperTelegram>
            <Text isCollapsed={isCollapsed}>Telegram Support</Text>
          </SupportButton>
        </Flex>
        <Flex
          onClick={support}
          style={{ marginTop: "20px", marginBottom: "20px" }}
        >
          <SupportButton>
            <IconWrapperSupport>
              <Headphones size={18} color="white" />
            </IconWrapperSupport>
            <Text isCollapsed={isCollapsed}>Live Support</Text>
          </SupportButton>
        </Flex> */}
      </div>
    </SidebarContainer>
  );
};

export default SidebarHello;
